// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file ActualScreeningAngle.proto (package ActualScreeningAngle, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ActualScreeningAngle.proto.
 */
export const file_ActualScreeningAngle: GenFile = /*@__PURE__*/
  fileDesc("ChpBY3R1YWxTY3JlZW5pbmdBbmdsZS5wcm90bxIUQWN0dWFsU2NyZWVuaW5nQW5nbGUisQIKFEFjdHVhbFNjcmVlbmluZ0FuZ2xlEi4KCmlzc2VsZWN0ZWQYASABKAsyGi5nb29nbGUucHJvdG9idWYuQm9vbFZhbHVlEicKAmlkGAIgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSLQoIbWF4YW5nbGUYAyABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRItCghtaW5hbmdsZRgEIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEi0KCG5hdmFpZFBrGAUgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSMwoNdmVydGljYWxhbmdsZRgGIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5Eb3VibGVWYWx1ZUJKCi1jb20uZ212LmRlbWV0ZXIubmF2YWlkcy5tb2RlbC5wcm90by5nZW5lcmF0ZWRCGUFjdHVhbFNjcmVlbmluZ0FuZ2xlUHJvdG9iBnByb3RvMw", [file_google_protobuf_wrappers]);

/**
 * @generated from message ActualScreeningAngle.ActualScreeningAngle
 */
export type ActualScreeningAngle = Message<"ActualScreeningAngle.ActualScreeningAngle"> & {
  /**
   * @generated from field: google.protobuf.BoolValue isselected = 1;
   */
  isselected?: boolean;

  /**
   * @generated from field: google.protobuf.Int32Value id = 2;
   */
  id?: number;

  /**
   * @generated from field: google.protobuf.Int32Value maxangle = 3;
   */
  maxangle?: number;

  /**
   * @generated from field: google.protobuf.Int32Value minangle = 4;
   */
  minangle?: number;

  /**
   * @generated from field: google.protobuf.Int32Value navaidPk = 5;
   */
  navaidPk?: number;

  /**
   * @generated from field: google.protobuf.DoubleValue verticalangle = 6;
   */
  verticalangle?: number;
};

/**
 * Describes the message ActualScreeningAngle.ActualScreeningAngle.
 * Use `create(ActualScreeningAngleSchema)` to create a new message.
 */
export const ActualScreeningAngleSchema: GenMessage<ActualScreeningAngle> = /*@__PURE__*/
  messageDesc(file_ActualScreeningAngle, 0);

